import React, { Component } from 'react';
import style from './LatestUpdateNews.module.css';
import Lottie from 'lottie-react';
import animation from '../../lottieAnimations/schedule_animation.json';
import icons from '../../icons';
import constants from '../../constants';


export default class LatestUpdateNews extends Component {
    constructor (props) {
        super(props);
        
        this.state = {
            linkCopied: false,
        };
    }

    render() {
        return (
            <main className={ style.main }>
                {/* <Lottie 
                    style={{ backgroundColor: "rgb(44, 44, 44)" }}
                    loop={ true }
                    autoplay={ true }
                    delay={ 5000 }
                    speed={ 0.1 }
                    animationData={ classroom_animation }
                    height={ 300 }
                    width={ 300 }
                />
                <h2 className={ style.newsHeader }>
                    Aggiornamento - sincronizzazione con Google Classroom
                </h2>
                <h3 className={ style.newsDescription }>
                    Collega il tuo account di <span>SchoolDiary</span> al tuo account di <span>Google Classroom</span> per attivare la sincronizzazione automatica dei compiti da <span>Classroom</span> a <span>SchoolDiary</span><br></br><br></br>
                    Vai nelle impostazioni e clicca sul tasto "Collega classroom" per sincronizzare i due account. Puoi usare un qualsiasi account <span>Google</span> per la sincronizzazione, anche diverso dall'indirizzo email che hai usato per registrarti su <span>SchoolDiary</span><br></br>
                </h3>
                <div className={ style.button } onClick={ () => {
                    localStorage.setItem("appVersion", constants.APP_VERSION)
                    this.props.setshowLatestUpdateNews(false);
                    this.props.setPage({ page: "settings", settingsPage: "classroom" });
                } } >
                    <img alt="" src={ icons.settings_icon } />
                    <h3>VAI ALLE IMPOSTAZIONI</h3>
                </div> 
                <div className={ style.button } style={{ background: "linear-gradient(to left, rgb(150, 85, 1), rgb(255, 115, 0))" }} onClick={ () => window.location.href = "/" } >
                    <img alt="" src={ icons.home_icon } />
                    <h3>VAI ALLA HOME</h3>
                </div> */}
                <Lottie 
                    style={{ backgroundColor: "rgb(44, 44, 44)", marginTop: "2rem", marginBottom: "2rem" }}
                    loop={ true }
                    autoplay={ true }
                    delay={ 5000 }
                    speed={ 0.1 }
                    animationData={ animation }
                    height={ 300 }
                    width={ 300 }
                />
                <h2 className={ style.newsHeader } style={{ fontSize: "1.5rem" }}>
                    Nuova sezione "Studio" e flashcards!
                </h2>
                <h3 className={ style.newsDescription } style={{ fontSize: "1.1rem" }}>
                    Studia al meglio con il <a href="https://it.wikipedia.org/wiki/Sistema_Leitner" target="_blank" style={{ color: "var(--orange)" }}>sistema Leitner</a> e le flashcards! Vai nella nuova sezione e comincia a creare le tue flashcards personalizzate per ogni argomento!
                </h3>
                <div className={ style.button } onClick={ () => {
                    this.props.setShowLatestUpdateNews(false);
                    this.props.setPage({ page: "study" });
                } } >
                    <img alt="" src={ icons.study_icon } />
                    <h3>FLASHCARDS</h3>
                </div> 
                <div className={ style.button } style={{ background: "linear-gradient(to left, rgb(150, 85, 1), rgb(255, 115, 0))" }} onClick={ () => this.props.setShowLatestUpdateNews(false) } >
                    <img alt="" src={ icons.home_icon } />
                    <h3>VAI ALLA HOME</h3>
                </div>
            </main>
        )
    }
}
